import { render, staticRenderFns } from "./ChooseIcon.vue?vue&type=template&id=b0a0fdee&scoped=true"
import script from "./ChooseIcon.vue?vue&type=script&lang=js"
export * from "./ChooseIcon.vue?vue&type=script&lang=js"
import style0 from "./ChooseIcon.vue?vue&type=style&index=0&id=b0a0fdee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a0fdee",
  null
  
)

export default component.exports